<script>
  import { useParams } from "svelte-navigator";
  import { onMount, onDestroy, tick, afterUpdate } from "svelte";
  import { writable, derived } from "svelte/store";
  import dayjs from "dayjs";
  import { fetchProductionWorks, fetchProductionOrders, fetchProductionOrderData, fetchTransactionData, fetchProjectData } from "../../../utils/getData.js"
  import { postStartEndData } from "../../../utils/putData.js"
  import { saveConfiguration, getConfiguration } from "../../../utils/configurationStorage/configurationStorage.js";
  import { usePageContext } from "../../../components/pages/pageContext.js";
  import Loading from "../../../components/pages/Loading.svelte";
  import { getNotificationsContext } from "svelte-notifications";

  import GuestProductionOrderMenuBar from "./GuestProductionOrderMenuBar.svelte";
  import GuestProductionOrderFixedTable from "./GuestProductionOrderFixedTable.svelte";
  import GuestProductionOrderScrollTable from "./GuestProductionOrderScrollTable.svelte";
  import { createProductionOrderFilters } from "./GuestProductionOrderFilters.js";
  import { group1, group2, group3 } from './columns.js';
  import { Filters } from "./stores.js";

  let group1_cols = [...group1];
  let group2_cols = [...group2];
  let group3_cols = [...group3];
  let windowWidth = window.innerWidth;
  let windowHeight = window.innerHeight;

  const { addNotification } = getNotificationsContext();

  let uploadTimeStamp = undefined;

  const params = useParams();
  const { setHeaderProps } = usePageContext();
  $: setHeaderProps({ title: "生産指示書" });
  $: setHeaderProps({ uploadTime: uploadTimeStamp});

  const project = $params.project;
  const token = null

  let ProductionWorks = null;
  let ProductionOrders = null;
  let TransactionData = null;
  let ProductionOrderDatas = null;
  let all_tableData = [];
  let tableData = [];
  let filter_applied = false;
  let filtered_tableData = [];
  let max_work_num = 1;
  let disable_buttons = false;  // While sending data, disable buttons

  // State for group visibility
  let visibility = writable({
    group1: true,
    group2: true,
    group3: true
  });
  // Function to toggle visibility
  function toggleGroupVisibility(group) {
    visibility.update(v => {
      v[group] = !v[group];
      return v;
    });
    
  }
  // Function to apply filter
  function applyFilter() {
    toggleFilterDialog();
    filterByConditions();
  }
  // Function to clear filter
  function clearFilter() {
    filter_year = "";
    filter_month = "";
    filter_process = "";
    filter_taseiban = "";
    filter_Work_OrderItem = "";
    filter_order = "";
    filter_completed = "";
  }

  // State for filter inputs
  // for '加工年'
  const current_datetime = dayjs();
  let filter_year = "";
  // for '加工月'
  let filter_month = "";

  // for '工程'
  let filter_process = "";
  let checked_processes;
  // for '製番'
  let filter_taseiban = "";
  // for '品番'
  let filter_Work_OrderItem = "";
  // for 'オーダ'
  let filter_order = "";
  // for '完了品'
  let filter_completed = "";
  /* let option_completed_strs = [{
    text: "未完了品",
    displayed: true,
    excluded: false,
  }, {
    text: "完了品",
    displayed: true,
    excluded: false,
  }]; */

  let preloading = false;

  const FilterableItems = derived([Filters], ([Filters]) => {
    return Object.fromEntries(
      Object.keys(Filters)
        .map(filterName => [filterName, Filters[filterName].getFilterItems(all_tableData, Filters)])
    )
  })

  let showDialog = false;
  // Function to filter table data
  function filterByConditions() {
    filtered_tableData = [];
    for (let i = 0; i < all_tableData.length; i++) {
      let row = all_tableData[i];
      
      let year_str = String(Number(row.Work_OperationProductionStartTime.replace('<span class="date-part">', '').split("/")[0]));
      let month_str = String(Number(row.Work_OperationProductionStartTime.replace('<span class="date-part">', '').split("/")[1]));
      if (filter_year && filter_year.length > 0 && filter_year.some(year => year_str === year)) {
        continue;
      }
      if (filter_month && filter_month.length > 0 && filter_month.some(month => month_str === month)) {
        continue;
      }
      if (filter_process && filter_process.length > 0 && filter_process.some(process => row.Work_OperationProcName.startsWith(process))) {
        continue;
      }
      if (filter_taseiban && filter_taseiban.length > 0 && filter_taseiban.some(taseiban => row.WorkUser_TaSeiban.startsWith(taseiban))) {
        continue;
      }
      if (filter_Work_OrderItem && filter_Work_OrderItem.length > 0 && filter_Work_OrderItem.some(item => row.Work_OrderItem.startsWith(item))) {
        continue;
      }
      if (filter_order && filter_order.length > 0 && filter_order.some(order => row.Order_Code.startsWith(order))) {
        continue;
      }
      if (filter_completed && filter_completed.length > 0) {
        if (filter_completed.length === 2) {
          continue;
        } else if (filter_completed[0] === "未完了品" && row.Work_ResultEndTime ==="") {
          continue;
        } else if (filter_completed[0] === "完了品" && row.Work_ResultEndTime != "") {
          continue;
        }
      }
      
      filtered_tableData.push({ ...row });
    }
    tableData=filtered_tableData;
    filter_applied = true;

    // Save filter_process, filter_Work_OrderItem, filter_order, and filter_completed
    if (preloading) {    
      const configuration = {
        "filter_year": filter_year,
        "filter_month": filter_month,
        "filter_process": filter_process,
        "filter_taseiban": filter_taseiban,
        "filter_Work_OrderItem": filter_Work_OrderItem,
        "filter_order": filter_order,
        /* "filter_completed": filter_completed, */
        "group1_cols": group1_cols,
        "group2_cols": group2_cols,
        "group3_cols": group3_cols,
      }
      saveConfiguration("ProductionOrder", "default", "default", configuration);
    }

  }
  $: filter_year, filterByConditions();
  $: filter_month, filterByConditions();
  $: filter_process, filterByConditions();
  $: filter_taseiban, filterByConditions();
  $: filter_Work_OrderItem, filterByConditions();
  $: filter_order, filterByConditions();
  $: filter_completed, filterByConditions();

  // Function to toggle filter dialog
  function toggleFilterDialog() {
    showDialog = !showDialog;
  }

  // Function to delete completed works
  async function deleteCompleted(row) {
    if (!confirm("着完を削除しますか？")) {
      return;
    }

    let payload;
    if (row.Work_ResultEndTime === "") {
      // Delete Work_ResultStartTime
      payload = JSON.stringify({
        [row.Work_OperationCode]: {
          "Work_Status": "A",
          "Work_ResultStartTime": "",
          "Work_ResultEndTime": "",
        }
      });
    } else {
      // Delete Work_ResultEndTime
      let dateTime = row.Work_ResultStartTime.replace('<span class="date-part">', '');
      dateTime = dateTime.replace('<span class="time-part">', '');
      dateTime = dateTime.replace(/<\/span>/g, '');
      let [datePart, timePart] = dateTime.split(" ");
      payload = JSON.stringify({
        [row.Work_OperationCode]: {
          "Work_Status": "T",
          "Work_ResultStartTime": datePart + " " + timePart,
        }
      });
    }

    disable_buttons = true;
    try {
      await postStartEndData(project, payload);
      await refresh();
      disable_buttons = false;
    } catch (e) {
      addNotification({
        text: "着完の削除に失敗しました。",
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      })
      disable_buttons = false;
    }
  }

  // Function to send result time
  async function sendResultTime(row, isStart) {
    const currentDatetime = dayjs().format("YYYY/MM/DD HH:mm:ss");
    if (!isStart && row.Work_ResultStartTime === "") {
      addNotification({
        text: "開始していない作業です。",
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      })
      return;
    }

    const payload = JSON.stringify({
      [row.Work_OperationCode]: {
        "Work_Status": isStart ? "T" : "B",
        "Work_ResultStartTime": isStart ? currentDatetime : undefined,
        "Work_ResultEndTime": isStart ? undefined : currentDatetime,
      }
    });

    disable_buttons = true;
    try {
      await postStartEndData(project, payload);
      await refresh();
      disable_buttons = false;
    } catch (e) {
      addNotification({
        text: "実績の送信に失敗しました。",
        position: "top-right",
        removeAfter: 4000,
        type: "error",
      })
      disable_buttons = false;
    }
  }

  function get_style(row, col) {
    if (col.key == "Work_Lateness") {
      if (row == null || row[col.key] <= 0) {
        return `width: ${col.width}px; height: 45px; max-height: 45px;`;
      } else {
        return `width: ${col.width}px; color: red; font-weight: bold; height: 45px; max-height: 45px;`;
      }
    } else {
      return `width: ${col.width}px; max-width: ${col.width}px; height: 45px; max-height: 45px;`;
    }
  }

  // Functions for resizer
  let dragging_col_key = null;
  function handleDrag(e) {
    // get th of col_key left x position
    const th = document.getElementById(`th_${dragging_col_key}`);
    const thRect = th.getBoundingClientRect();
    const thLeft = thRect.left;

    const newColWidth = e.clientX - thLeft;
    /* if (newColWidth < 70) {
      return;
    } */

    for (let i = 0; i < group1_cols.length; i++) {
      if (group1_cols[i].key === dragging_col_key) {
        group1_cols[i].width = Math.max(newColWidth, group1_cols[i].minWidth);
      }
    }
    for (let i = 0; i < group2_cols.length; i++) {
      if (group2_cols[i].key === dragging_col_key) {
        group2_cols[i].width = Math.max(newColWidth, group1_cols[i].minWidth);
      }
    }
    for (let i = 0; i < group3_cols.length; i++) {
      if (group3_cols[i].key === dragging_col_key) {
        group3_cols[i].width = Math.max(newColWidth, group1_cols[i].minWidth);
      }
    }
    adjustRowHeights();
  }

  function stopDrag(e) {
    dragging_col_key = null;
    window.removeEventListener('mousemove', handleDrag);
    window.removeEventListener('mouseup', stopDrag);
    // Save filter_process, filter_taseiban, filter_Work_OrderItem, filter_order, and filter_completed
    const configuration = {
      "filter_process": filter_process,
      "filter_taseiban": filter_taseiban,
      "filter_Work_OrderItem": filter_Work_OrderItem,
      "filter_order": filter_order,
      /* "filter_completed": filter_completed, */
      "group1_cols": group1_cols,
      "group2_cols": group2_cols,
      "group3_cols": group3_cols,
    }
    saveConfiguration("ProductionOrder", "default", "default", configuration);
  }

  function startDrag(e) {
  const target = e.target;
  if (!(target instanceof HTMLElement)) return;
  if (!target.id || !target.id.startsWith("resizer_")) return;

  e.preventDefault();

  dragging_col_key = target.id.replace("resizer_", "");

  window.addEventListener("mousemove", handleDrag);
  window.addEventListener("mouseup", stopDrag);
}

  const isValidDate = d => {
    const date = new Date(d);
    return !isNaN(date);
  };

  function get_work_row_class(work, currentProcNo) {
    let res = "";
    if (checked_processes && checked_processes.includes(work.Work_OperationProcName) && work.Work_OperationCode.split(':')[1] === currentProcNo.toString()) {
      res += "search-hitted ";
    }

    if (isValidDate(work.Work_ResultEndTime)) {
      res += "completed ";
    } else if (isValidDate(work.Work_ResultStartTime)) {
      res += "in-progress ";
    } else {
      res += "not-started ";
    }
    
    return res;
  }

  function preprocessTableData(tableData) {
    return tableData.map(row => {
      const updatedWorks = row.Works.map(work => {
        let res = "";

        if (
          checked_processes &&
          checked_processes.includes(work.Work_OperationProcName) &&
          work.Work_OperationCode.split(':')[1] === row.Work_OperationProcNo.toString()
        ) {
          res += "search-hitted ";
        }

        const start_time = dayjs(work.Work_ResultStartTime);
        const end_time = dayjs(work.Work_ResultEndTime);
        if (end_time.isValid()) {
          res += "completed ";
        } else if (start_time.isValid()) {
          res += "in-progress ";
        } else {
          res += "not-started ";
        }

        return {
          ...work,
          __className: res.trim()
        };
      });

      return {
        ...row,
        Works: updatedWorks
      };
    });
  }

  function get_work_row_block_right_content(work) {
    
    const result_start_time = dayjs(work.Work_ResultStartTime);
    const result_end_time = dayjs(work.Work_ResultEndTime);
    const production_start_time = dayjs(work.Work_OperationProductionStartTime);
    if (result_end_time.isValid()) {
      return "●";
    } else if (result_start_time.isValid()) {
      return "○";
    } else {
      return production_start_time.format("MM") + "/" + production_start_time.format("DD");
    }
  }

  let rowHeight = 45;
  function adjustRowHeights() {
    const fixedRow = document.querySelector('.fixed-table-container tbody tr');
    const allFixedRows = document.querySelectorAll('.fixed-table-container tbody tr');
    const allScrollRows = document.querySelectorAll('.scrollable-table-body tbody tr');
    if (!fixedRow) return;
    allFixedRows.forEach((fixedRow, i) => {
      if (!allScrollRows[i]) return;
      // Measure heights
      const fixedHeight = fixedRow.getBoundingClientRect().height;
      const scrollHeight = allScrollRows[i].getBoundingClientRect().height;
      if (scrollHeight != fixedHeight) {
        allScrollRows[i].style.height = fixedHeight + 'px';
      }
    });
  }


  function format_date_time(date) {
      if (date === "") {
        return "";
      }
      const [datePart, timePart] = dayjs(date).format("YYYY/MM/DD HH:mm").split(" ");
      if (dayjs(date).format("YYYY/MM/DD HH:mm") === "Invalid Date") {
        return "";
      }
      return `<span class="date-part">${datePart}</span> <span class="time-part">${timePart}</span>`;
    }

  async function refresh() {
    const projectData = await fetchProjectData(project, "ProductionOrder");
    if (uploadTimeStamp != projectData.UploadTimeStamp) {
      // Upload time changed. Update with Entire data
      uploadTimeStamp = projectData.UploadTimeStamp;
      ProductionWorks = await fetchProductionWorks(project);
      ProductionOrders = await fetchProductionOrders(project);
      TransactionData = await fetchTransactionData(project, null);
      ProductionOrderDatas = {};
      for (let i = 0; i < ProductionOrders.Orders.length; i++) {
        let Order_ObjectID = ProductionOrders.Orders[i];
        let data = await fetchProductionOrderData(project, Order_ObjectID);
        ProductionOrderDatas[Order_ObjectID] = data;
        max_work_num = Math.max(max_work_num, data.Order.Works.length);
      }
      function extract_month_and_day(date) {
        if (date === "") {
          return "";
        }
        return date.split(" ")[0].split("/").slice(1).join("/");
      }

      all_tableData = [];
      for (let i = 0; i < ProductionWorks.Works.length; i++) {
        let row_data = ProductionWorks.Works[i];
        let Order_ObjectID = row_data.Order_ObjectID;
        if (!ProductionOrderDatas[Order_ObjectID]) {
          continue;
        }
        let data = ProductionOrderDatas[Order_ObjectID];
        row_data["Order_LET"] = extract_month_and_day(row_data["Order_LET"]);
        row_data["Work_OperationProductionStartTime"] = format_date_time(row_data["Work_OperationProductionStartTime"]);
        row_data["Work_OperationProductionEndTime"] = format_date_time(row_data["Work_OperationProductionEndTime"]);
        row_data["Work_ResultStartTime"] = format_date_time(row_data["Work_ResultStartTime"]);
        row_data["Work_ResultEndTime"] = format_date_time(row_data["Work_ResultEndTime"]);
        row_data["Work_Lateness"] = Math.max(0, Math.floor(row_data["Work_Lateness"] * 10 / 3600 / 24) / 10);
        row_data["completedReset"] = "";
        row_data["Works"] = data.Order.Works;
        all_tableData.push(row_data);
      }

      for (let Work_OperationCode in TransactionData) {
        if (Work_OperationCode == "DownloadedTimeStamp") {
          continue;
        }
        let Work_Status = TransactionData[Work_OperationCode].Work_Status;
        if (Work_Status === "A") {
          for (let i = 0; i < all_tableData.length; i++) {
            let row = all_tableData[i];
            if (row.Work_OperationCode === Work_OperationCode) {
              row.Work_ResultStartTime = "";
              row.Work_ResultEndTime = "";
              for (let j = 0; j < row.Works.length; j++) {
                if (row.Works[j].Work_OperationCode === Work_OperationCode) {
                  row.Works[j].Work_ResultStartTime = "";
                  row.Works[j].Work_ResultEndTime = "";
                  break;
                }
              }
              break;
            }
          }
        } else if (Work_Status === "T") {
          let Work_ResultStartTime = TransactionData[Work_OperationCode].Work_ResultStartTime;
          for (let i = 0; i < all_tableData.length; i++) {
            let row = all_tableData[i];
            if (row.Work_OperationCode === Work_OperationCode) {
              row.Work_ResultStartTime = format_date_time(Work_ResultStartTime);
              row.Work_ResultEndTime = "";
              for (let j = 0; j < row.Works.length; j++) {
                if (row.Works[j].Work_OperationCode === Work_OperationCode) {
                  row.Works[j].Work_ResultStartTime = Work_ResultStartTime;
                  row.Works[j].Work_ResultEndTime = "";
                  break;
                }
              }
              break;
            }
          }
        } else if (Work_Status === "B") {
          let Work_ResultStartTime = TransactionData[Work_OperationCode].Work_ResultStartTime || "";
          let Work_ResultEndTime = TransactionData[Work_OperationCode].Work_ResultEndTime || "";
          for (let i = 0; i < all_tableData.length; i++) {
            let row = all_tableData[i];
            if (row.Work_OperationCode === Work_OperationCode) {
              if (Work_ResultStartTime !== "") row.Work_ResultStartTime = format_date_time(Work_ResultStartTime);
              if (Work_ResultEndTime !== "") row.Work_ResultEndTime = format_date_time(Work_ResultEndTime);
              for (let j = 0; j < row.Works.length; j++) {
                if (row.Works[j].Work_OperationCode === Work_OperationCode) {
                  if (Work_ResultStartTime !== "") row.Works[j].Work_ResultStartTime = Work_ResultStartTime;
                  if (Work_ResultEndTime !== "") row.Works[j].Work_ResultEndTime = Work_ResultEndTime;
                  break;
                }
                
              }
              break;
            }
          }
        }
      }
      all_tableData.sort((a, b) => {
        if (a.Work_OperationProductionStartTime < b.Work_OperationProductionStartTime) {
          return -1;
        } else if (a.Work_OperationProductionStartTime > b.Work_OperationProductionStartTime) {
          return 1;
        } else {
          return 0;
        }
      });



      async function updateFilters(all_tableData) {
        Filters.set(createProductionOrderFilters(all_tableData)); // Set Filters
        await tick(); // Wait for Svelte's reactivity system to settle
      }
      await updateFilters(all_tableData);

    } else {
      // Upload time unchanged. Only update with TransactionData
      TransactionData = await fetchTransactionData(project, null);
      for (let Work_OperationCode in TransactionData) {
        if (Work_OperationCode == "DownloadedTimeStamp") {
          continue;
        }
        let Work_Status = TransactionData[Work_OperationCode].Work_Status;
        if (Work_Status === "A") {
          for (let i = 0; i < all_tableData.length; i++) {
            let row = all_tableData[i];
            if (row.Work_OperationCode === Work_OperationCode) {
              row.Work_ResultStartTime = "";
              row.Work_ResultEndTime = "";
              for (let j = 0; j < row.Works.length; j++) {
                if (row.Works[j].Work_OperationCode === Work_OperationCode) {
                  row.Works[j].Work_ResultStartTime = "";
                  row.Works[j].Work_ResultEndTime = "";
                  break;
                }
              }
              break;
            }
          }
        } else if (Work_Status === "T") {
          let Work_ResultStartTime = TransactionData[Work_OperationCode].Work_ResultStartTime;
          for (let i = 0; i < all_tableData.length; i++) {
            let row = all_tableData[i];
            if (row.Work_OperationCode === Work_OperationCode) {
              row.Work_ResultStartTime = format_date_time(Work_ResultStartTime);
              row.Work_ResultEndTime = "";
              for (let j = 0; j < row.Works.length; j++) {
                if (row.Works[j].Work_OperationCode === Work_OperationCode) {
                  row.Works[j].Work_ResultStartTime = Work_ResultStartTime;
                  row.Works[j].Work_ResultEndTime = "";
                  break;
                }
              }
              break;
            }
          }
        } else if (Work_Status === "B") {
          let Work_ResultStartTime = TransactionData[Work_OperationCode].Work_ResultStartTime || "";
          let Work_ResultEndTime = TransactionData[Work_OperationCode].Work_ResultEndTime || "";
          for (let i = 0; i < all_tableData.length; i++) {
            let row = all_tableData[i];
            if (row.Work_OperationCode === Work_OperationCode) {
              if (Work_ResultStartTime !== "") row.Work_ResultStartTime = format_date_time(Work_ResultStartTime);
              if (Work_ResultEndTime !== "") row.Work_ResultEndTime = format_date_time(Work_ResultEndTime);
              for (let j = 0; j < row.Works.length; j++) {
                if (row.Works[j].Work_OperationCode === Work_OperationCode) {
                  if (Work_ResultStartTime !== "") row.Works[j].Work_ResultStartTime = Work_ResultStartTime;
                  if (Work_ResultEndTime !== "") row.Works[j].Work_ResultEndTime = Work_ResultEndTime;
                  break;
                }
                
              }
              break;
            }
          }
        }
      }
    }

    filterByConditions();
  }

  // Functions for resizer of the scrollable talbe
  let dragging_col_scroll = null;
  let initialX = 0;
  let initialWidth = 0;
  let workHeaderWidth = 90;
  function handleDragS(e) {
    const newColWidth = e.clientX - initialX;
    workHeaderWidth = Math.max(initialWidth + newColWidth/(parseInt(dragging_col_scroll)+1), 65);
  }

  function stopDragS(e) {
    window.removeEventListener('mousemove', handleDragS);
    window.removeEventListener('mouseup', stopDragS);
  }

  function startDragS(e) {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    if (!target.id || !target.id.startsWith("resizer_s_")) return;

    e.preventDefault();

    dragging_col_scroll = target.id.replace("resizer_s_", "");
    const thEl = document.getElementById(`th_s_${dragging_col_scroll}`);
    if (!thEl) return;

    initialX = e.clientX;
    initialWidth = thEl.offsetWidth;

    window.addEventListener('mousemove', handleDragS);
    window.addEventListener('mouseup', stopDragS);
  }

  // handle scroll function

  function handleScroll(e) {
    const containers = document.querySelectorAll('.horizontal-scroll');
    const scrollTableBody = document.querySelector('.scrollable-table-container');
    if (e.ctrlKey) {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -5 : 5; // Scroll down to decrease, scroll up to increase
      workHeaderWidth = Math.max(workHeaderWidth + delta, 65);
    } else if (e.shiftKey) {
      e.preventDefault();
      scrollTableBody.scrollLeft += e.deltaY;
    } else {
      if (containers[0].contains(e.target)) {
        e.preventDefault();
        scrollTableBody.scrollLeft += e.deltaY;
      }
    }
  }

  function handleScrollF(e) {
    if (e.ctrlKey || e.shiftKey) {
      e.preventDefault();
    } else {
      e.preventDefault();
      if (fixedTable) {
        fixedTable.scrollTop += e.deltaY;
      }
    }
  }

  function handleResize() {
    windowWidth = window.innerWidth;
    windowHeight = window.innerHeight;
  }


  let fixedTable;
  let table1Width = 0;
  let resizeObserver;
  onMount(async () => {
    const configuration = getConfiguration("ProductionOrder", "default", "default");
    filter_year = configuration["filter_year"] ||[];
    filter_month = configuration["filter_month"] || [];
    filter_process = configuration["filter_process"] || [];
    filter_taseiban = configuration["filter_taseiban"] || [];
    filter_Work_OrderItem = configuration["filter_Work_OrderItem"] || [];
    filter_order = configuration["filter_order"] || [];
    /* filter_completed = configuration["filter_completed"] || ""; */

    if (group1_cols.minWidth != undefined && group2_cols.minWidth != undefined && group3_cols.minWidth != undefined) {
      group1_cols = configuration["group1_cols"]
      group2_cols = configuration["group2_cols"]
      group3_cols = configuration["group3_cols"]
    }
    preloading = true;
    /* if (filter_process === "" && filter_Work_OrderItem === "" && filter_order === "") {
      addNotification({
        text: "検索したい工程or品番orオーダを入力し絞り込みボタンを押してください。",
        position: "top-right",
        removeAfter: 4000,
        type: "success",
      });
    } */

    await refresh();
    adjustRowHeights();
    // Create a new ResizeObserver
    if (fixedTable) {
      resizeObserver = new ResizeObserver(() => {
        table1Width = fixedTable.offsetWidth; // Update width when div changes size
      });
      // Start observing the fixedTable element
      resizeObserver.observe(fixedTable);
    }
      // Disconnect the ResizeObserver when the component is unmounted
    
    window.addEventListener('resize', handleResize);
  });
  afterUpdate(() => {
    adjustRowHeights();
  });
  onDestroy(() => {
    if (resizeObserver) resizeObserver.disconnect();
    window.removeEventListener('resize', handleResize);
  });
</script>

{#if all_tableData.length === 0}
  <Loading />
{:else}
  <div class="main-container">
    <GuestProductionOrderMenuBar
      bind:filter_year
      bind:filter_month
      bind:filter_process
      bind:filter_taseiban
      bind:filter_Work_OrderItem
      bind:filter_order
      bind:filter_completed
      bind:checked_processes
      option_years={$FilterableItems["YearFilter"]}
      option_months={$FilterableItems["MonthFilter"]}
      option_processes={$FilterableItems["ProcessFilter"]}
      option_taseibans={$FilterableItems["TaseibanFilter"]}
      option_Work_OrderItems={$FilterableItems["WorkOrderItemFilter"]}
      option_orders={$FilterableItems["OrderFilter"]}
      option_completed_strs={$FilterableItems["CompletedFilter"]}
      filterByConditions={filterByConditions}
      refresh={refresh}
    />

    <div class="table-container" id="main-table">
      
      <GuestProductionOrderFixedTable 
        group1_cols={group1_cols}
        group2_cols={group2_cols}
        group3_cols={group3_cols}
        get_style={get_style}
        toggleGroupVisibility={toggleGroupVisibility}
        visibility={visibility}
        startDrag={startDrag}
        tableData={tableData}
        deleteCompleted={deleteCompleted}
        disable_buttons={disable_buttons}
        sendResultTime={sendResultTime}
        bind:fixedTable={fixedTable}
        handleScrollF={handleScrollF}
        tableHeight={tableData.length != 0 ? windowHeight-48-58 : 60+17}
      />
      
      <GuestProductionOrderScrollTable 
        max_work_num={max_work_num}
        workHeaderWidth={workHeaderWidth}
        startDragS={startDragS}
        get_work_row_class={get_work_row_class}
        get_work_row_block_right_content={get_work_row_block_right_content}
        tableData={tableData}
        tableHeight={tableData.length != 0 ? windowHeight-48-58 : 60+17}
        scrollableTableWidth={windowWidth-table1Width}
        handleScroll={handleScroll}
        rowHeight={rowHeight}
        preprocessTableData={preprocessTableData}
      />
      
    </div>

    {#if tableData.length === 0}
      <div style="margin-top: 16px; margin-left: 16px; color: #888888;">
        全作業数 = {all_tableData.length}個 
        {#if filter_applied}
          (該当する作業は存在しませんでした)
        {:else}
          (フィルタを設定すると表示されます)
        {/if}
      </div>
   {/if}
  </div>

{/if}

<style>
  .main-container {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    height: 100%;
    overflow: hidden;
  }

  .table-container {
    display: flex;
    align-items: flex-start;
  }
</style>